import React from 'react';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <header className="header">
        <div className="header-brand">
          <img className="header-logo" src="/asset/logo.jpeg" alt="TheHarpsAndStrings Logo" />
          <h1 className="title"><span className="cursive-font">Theharpsandstrings</span></h1>
        </div>
        <nav className="nav">
          <a href="#home">Home</a>
          <a href="#gallery">Releases</a>
          <a href="#about">About</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>
      <section id="home" className="hero">
        <div className="hero-content">
          <h2 className="hero-title">Welcome to the World of Music with <span className="cursive-font">Theharpsandstrings</span></h2>
          <p className="hero-text">Discover breathtaking creations that inspire and captivate.</p>
        </div>
      </section>
      <section id="gallery" className="gallery">
        <h2 className="section-title">Releases</h2>
        <div className="releases-grid">
          <div className="releases-column">
            <h3 className="releases-column-title">Music</h3>
            <a className="release-item" href="https://open.spotify.com/track/2rezwmiZJ4UdgCZYnGzbUh?si=afe6973e5387485b" target="_blank" rel="noreferrer">
              <span className="release-number">01</span>
              <img className="release-logo" src="/asset/baby_album_row.jpeg" alt="Nursery Rhymes" />
              <div className="release-details">
                <h3>Nursery Rhymes</h3>
                <p>Playful lullabies and gentle melodies</p>
              </div>
            </a>
            <a className="release-item" href="https://open.spotify.com/track/4Jy5Hu0wB7j2r8l332LNQ2?si=1b8192c5a752467a" target="_blank" rel="noreferrer">
              <span className="release-number">02</span>
              <img className="release-logo" src="/asset/HappyBirthday.jpeg" alt="Happy Birthday" />
              <div className="release-details">
                <h3>Happy Birthday</h3>
                <p>Joyful celebration song for every age</p>
              </div>
            </a>
          </div>
          <div className="releases-column">
            <h3 className="releases-column-title">Stories</h3>
            <div className="release-item">
              <span className="release-number">01</span>
              <div className="release-details">
                <iframe data-testid="embed-iframe" src="https://open.spotify.com/embed/track/0xLPitVTnbEvlLaVDw6dV3?utm_source=generator&si=b98f6bccbb4948b2" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
              </div>
            </div>
            <div className="release-item">
              <span className="release-number">02</span>
              <div className="release-details">
                <iframe data-testid="embed-iframe" src="https://open.spotify.com/embed/track/73tC6DnwGf9wXqZcQ0HPh9?utm_source=generator&si=ba276e4979ed49c7" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
              </div>
            </div>
            <div className="release-item">
              <span className="release-number">03</span>
              <div className="release-details">
                <iframe data-testid="embed-iframe" src="https://open.spotify.com/embed/track/6dKfjFcjsQMclHGNYM35Nq?utm_source=generator&si=6d3d7431e7d7493b" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
              </div>
            </div>
            <div className="release-item">
              <span className="release-number">04</span>
              <div className="release-details">
                <iframe data-testid="embed-iframe" src="https://open.spotify.com/embed/track/640vmokFWcETwiNAFFGKnr?utm_source=generator&si=65cde62633ac4de1" width="100%" height="152" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="about" className="about">
        <h2 className="section-title">About the Artist</h2>
        <p className="about-text">Passionate about creating music that tells stories and evokes emotions. Each piece is a journey into imagination.</p>
      </section>
      <footer className="footer">
        <p>&copy; 2026 theharpsandstrings. All rights reserved.</p>
        <div className="footer-links">
          <span>Follow us:</span>
          <a href="https://open.spotify.com/artist/4fbIl15ZGodcCvbNfFsErh?si=4SKWm758QoaXxPNuEev6AA" target="_blank" rel="noreferrer">Spotify</a>
          <a href="https://music.apple.com/in/artist/theharpsandstrings/1787128473" target="_blank" rel="noreferrer">Apple Music</a>
          <a href="https://youtube.com/channel/UCyJncV7YPmrYMwge4bufbAw?si=uk2CD27apzhhynOK" target="_blank" rel="noreferrer">YouTube</a>
        </div>
      </footer>
    </div>
  );
};

export default App;
